import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const ContentLearnerApi = createApi({
  reducerPath: "ContentLearnerApi",
  baseQuery: customBaseQuery,
  tagTypes: ["ContentlearnerCount"],
  endpoints: (builder) => ({
    getcontentLearnerCountApi: builder.query({
      query: (contentId) => {
        return {
          url: `/progress/learnerCount/${contentId}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Progress" }
    })
  })
});

export const {
  useLazyGetcontentLearnerCountApiQuery,
  useGetcontentLearnerCountApiQuery
} = ContentLearnerApi;
